<template>
	<div
		class="tab-item active"
		data-tab="details"
	>
		<div class="block">
			<div class="block__headline">
				<div class="block__title headline-1">
					<i class="icon-grp-1 block__icon"></i>
					{{ $t('details') }}
				</div>
			</div>
			<div class="details">
				<div
					v-if="(type === 'collection' || type === 'event') && correctedItem?.logo?.url"
					class="details-swiper swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden"
				>
					<img
						:src="img"
						:srcset="`${img}, ${img2x} 2x`"
						:alt="correctedItem.name"
						class="img img--cover"
					>
				</div>
				<div class="details-data">
					<div class="details-data__row">
						<NuxtLink
							v-if="item?.event_type"
							:to="`${item?.event_type?.url}`"
							class="details-badge icon-chear body-2 bg-orange"
						>
							{{ item?.event_type?.name }}
						</NuxtLink>

						<template v-if="correctedItem?.blockchains">
							<template v-if="Array.isArray(correctedItem?.blockchains)">
								<NuxtLink
									v-for="blockchain in correctedItem.blockchains"
									class="details-badge icon-blockchain body-2 bg-pink"
									:to="blockchain.url"
								>
									{{ blockchain.name }}
								</NuxtLink>
							</template>

							<NuxtLink
								v-else
								class="details-badge icon-blockchain body-2 bg-pink"
								:to="correctedItem.blockchains.url"
							>
								{{ correctedItem.blockchains.name }}
							</NuxtLink>
						</template>

                        <NuxtLink
							v-for="utility in correctedItem?.utilities"
							:key="utility.name"
							:to="utility.url"
							class="details-badge icon-category body-2"
						>
							{{ utility.name }}
						</NuxtLink>
						<NuxtLink
							v-for="utility in correctedItem?.arts"
							:key="utility.name"
							:to="utility.url"
							class="details-badge icon-category body-2"
						>
							{{ utility.name }}
						</NuxtLink>
						<Menu v-if="correctedItem?.marketplaces?.length" v-model="isShowMenu" icon label="Marketplace">
							<div class="menu__list menu__list_align_right">
								<a v-for="market in correctedItem.marketplaces" :href="market.url" target="_blank" class="menu__item">
									{{market.name}}
								</a>
							</div>
						</Menu>
					</div>
					<div class="details-data__row">
						<a
							v-if="correctedItem?.roadmap_url"
							:href="correctedItem.roadmap_url"
							target="_blank"
							class="btn btn--gr btn-text"
						>
							<span class="btn__value">Roadmap</span>
						</a>
						<a
							v-if="correctedItem?.whitepaper_url"
							:href="correctedItem.whitepaper_url"
							target="_blank"
							class="btn btn--gr btn-text"
						>
							<span class="btn__value">Whitepaper</span>
						</a>
					</div>

					<p class="details-data__about body-1">
						{{ item.description }}
					</p>
					<!--					<div class="details-data__row pt-1d2">-->
					<!--						<button class="btn btn&#45;&#45;border btn-text"><span class="btn__value">Read more</span></button>-->
					<!--					</div>-->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TabDetails',
	props: {
		type: {
			type: String,
			required: true
		},
		item: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			isShowMenu: false
		}
	},
	computed: {
		correctedItem() {
			return this.item?.collection ? this.item.collection : this.item
		},
		img() {
			return `${this.$config.public.HOST_BACKEND}${this.correctedItem?.logo?.url+'/l.webp' || this.defaultImg}`;
		},
		img2x() {
			return `${this.$config.public.HOST_BACKEND}${this.correctedItem?.logo?.url+'/l2x.webp' || this.defaultImg}`;
		},
	}
}
</script>
